<template>
  <div>
    <div class="redeem-detail__header">
      <Heading class="redeem-detail__text" :level="3">Resgate em até</Heading>
      <template
        v-for="(item, index) in modalInfo?.details?.redemption?.description"
      >
        <BaseText
          :key="index"
          :color="nebraska.textSecondary"
          as="p"
          size="md"
          class="redeem-detail__content"
        >
          {{ item }}
        </BaseText>
      </template>
    </div>
    <div class="redeem-detail__wrapper">
      <Row
        v-for="(item, index) in sortedPortfolioSummary"
        :key="index"
        :has-line="index !== 0"
      >
        <template #top-left>
          <BaseText :color="nebraska.textSecondary" size="md">
            {{ item.name }}
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="nebraska.textPrimary" size="md">
            {{ item.expirationTime.formatted }}
          </BaseText>
        </template>
      </Row>
      <Row has-line>
        <template #top-left>
          <BaseText
            class="redeem-detail__bold-title"
            :color="nebraska.textPrimary"
            size="md"
          >
            Resgate da carteira em até
          </BaseText>
        </template>
        <template #top-right>
          <BaseText :color="nebraska.textPrimary" size="md">
            {{ modalInfo?.details?.allocations?.portfolioLiquidity }}
          </BaseText>
        </template>
      </Row>
    </div>
    <ButtonContainer>
      <template #button-primary>
        <ButtonPrimary
          data-testid="close-button"
          label="Entendi"
          @click="closeModal()"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script setup lang="ts">
import { inject, computed } from 'vue';
import {
  Row,
  Heading,
  ButtonContainer,
  ButtonPrimary,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPortfolioSummary } from '@/modules/wealth/services/investment/investment-types';
import { IDetailModalProps } from '../../types';

const nebraska = NebraskaColors;

const closeModal = inject('closeDetailModal') as () => void;

const props = defineProps<{
  modalInfo: IDetailModalProps;
}>();

const sortedPortfolioSummary = computed(() => {
  const portfolioSummary = Array.isArray(
    props.modalInfo?.details?.allocations?.portfolioSummary
  )
    ? props.modalInfo.details.allocations.portfolioSummary
    : [];

  return [...portfolioSummary].sort(
    (a: IPortfolioSummary, b: IPortfolioSummary) =>
      a.expirationTime.value - b.expirationTime.value
  );
});
</script>

<style lang="less" scoped>
.redeem-detail {
  &__text {
    margin-bottom: 0;
    text-align: start;
  }

  &__header {
    padding: 0 @size-spacing-x500 @size-spacing-x500 @size-spacing-x500;
  }
  &__wrapper {
    padding: 0 @size-spacing-x500 @size-spacing-x500 @size-spacing-x500;
  }

  @media (min-width: 1024px) {
    &__header {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
    &__wrapper {
      padding: 0 @size-spacing-x1000 @size-spacing-x600 @size-spacing-x1000;
    }
  }

  &__faq-link {
    text-decoration: none;
    font-weight: bold;
  }
  &__bold {
    font-weight: bold;
  }

  &__bold-title {
    width: max-content;
  }

  &__content {
    margin: @size-spacing-x600 0 @size-spacing-x350 0;
    text-align: start;
  }
}
</style>
